import axios from "axios";

const ENDPOINT_PATH = process.env.VUE_APP_API_DATOS;

console.log("api: " + ENDPOINT_PATH);
export default {
  usuarios() {
    return ENDPOINT_PATH + "webapi.ldes/api/Persona/";
  },
  traedps(plan) {
    return this.callApi(ENDPOINT_PATH + "Planes/ConsultaDps/"+plan, "post");
  },
  traeterminos(plan) {
    return this.callApi(ENDPOINT_PATH + "Planes/ConsultaTerminos/"+plan, "post");
  },
  aprobar(simulacion) {
    return this.callApi(ENDPOINT_PATH + "LineaDesgravamen/PropuestaAprobar", "post",simulacion);
  },
  consultabeneficios(plan) {
    return this.callApi(ENDPOINT_PATH + "Planes/ConsultaBeneficios/"+plan, "post");
  },
  traeusuarios() {
    return this.callApi(ENDPOINT_PATH + "usuarios", "post");
  },
  editar(id) {
    return this.callApi(
      ENDPOINT_PATH + "usuario/" + id + "/editar/usuario",
      "post"
    );
  },
  traeroles() {
    return this.callApi(ENDPOINT_PATH + "usuario/roles", "post");
  },
  estado(usuario) {
    return this.callApi(ENDPOINT_PATH + "usuario/estado", "post", usuario);
  },
  guardarsimulacion(usuario) {
    return this.callApi(ENDPOINT_PATH + "Simulacion/Propuesta", "post",usuario);
  },
  actualizar(usuario) {
    return this.callApi(
      ENDPOINT_PATH + "usuario/" + usuario.id + "/actualizar/usuario",
      "put",
      usuario
    );
  },
  eliminar(id) {
    return this.callApi(
      ENDPOINT_PATH + "usuario/" + id + "/eliminar",
      "delete"
    );
  },

  async callApi(ruta, method = false, data = false) {
    try {
      if (method == "post") {
        return await axios
          .post(ruta, data)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            let erdis = "";
            if (error.response.data.errors) {
              const er = error.response.data.errors;
              if (er.usuario) {
                erdis + " error usuario : ";
                er.usuario.forEach((element) => {
                  erdis = erdis + " " + element;
                });
              }
              if (er.nombre) {
                erdis + " error nombre : ";
                er.nombre.forEach((element) => {
                  erdis = erdis + " " + element;
                });
              }
              if (er.email) {
                erdis + " error email : ";
                er.email.forEach((element) => {
                  erdis = erdis + " " + element;
                });
              }
              if (er.password) {
                erdis = erdis + " error password : ";
                er.password.forEach((element) => {
                  erdis = erdis + " " + element;
                });
              }
              return { data: { success: false, message: erdis }, status: 200 };
            }
            return {
              data: { success: false, message: "Error no capturado" },
              status: 200,
            };
          });
      }
      if (method == "delete") {
        return await axios.delete(ruta, data).catch(function (error) {
          return false;
        });
      }
      if (method == "get") {
        return await axios.get(ruta, data).catch(function (error) {
          return false;
        });
      }
      if (method == "put") {
        return await axios
          .put(ruta, data)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
            console.log(error.config);
          });
      }
    } catch (error) {}
  },
};
